import { BrowserNotSupportedPopup } from "~/common/components/BrowserNotSupportedPopup/BrowserNotSupportedPopup";

export function createBrowserNotSupportedPopup() {
  return <BrowserNotSupportedPopup />;
}
